import type { ParseKeys, Resources } from "i18next";

type CatalogNamespace = keyof Resources;

/**
 * A catalog key written `ns:key`, optionally narrowed to some namespaces:
 * `I18nKey<"model">`. Plural keys appear once, without their `_one`/`_other`
 * suffix. A `t` from `useTranslation([...])` accepts it when its namespace is
 * in that list.
 */
export type I18nKey<N extends CatalogNamespace = CatalogNamespace> = {
  [K in N]: `${K}:${ParseKeys<K>}`;
}[N];

/**
 * What module-level tables and enum maps store instead of English text:
 * `name: tKey("model:augmentation.flip.name")`, rendered later with
 * `t(def.name)`. It returns the key unchanged; the call exists so tsc checks
 * the key against the `en` catalog and i18next-cli (`extract.functions` in
 * `i18next.config.ts`) counts it as a use.
 */
export const tKey = <K extends I18nKey>(key: K): K => key;
